import { render, staticRenderFns } from "./v-magazine.vue?vue&type=template&id=54e70ecc&scoped=true&"
import script from "./v-magazine.vue?vue&type=script&lang=js&"
export * from "./v-magazine.vue?vue&type=script&lang=js&"
import style0 from "./v-magazine.vue?vue&type=style&index=0&id=54e70ecc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e70ecc",
  null
  
)

export default component.exports